/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchCompaniesRequest
 */
export interface SearchCompaniesRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchCompaniesRequest
     */
    query?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchCompaniesRequest
     */
    isDemo?: boolean | null;
}

/**
 * Check if a given object implements the SearchCompaniesRequest interface.
 */
export function instanceOfSearchCompaniesRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchCompaniesRequestFromJSON(json: any): SearchCompaniesRequest {
    return SearchCompaniesRequestFromJSONTyped(json, false);
}

export function SearchCompaniesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchCompaniesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'query': !exists(json, 'query') ? undefined : json['query'],
        'isDemo': !exists(json, 'is_demo') ? undefined : json['is_demo'],
    };
}

export function SearchCompaniesRequestToJSON(value?: SearchCompaniesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'query': value.query,
        'is_demo': value.isDemo,
    };
}

